import React from 'react';
import { Box } from '@common-fe/common-fe';

import {
  SETUP_CONTAINER_UI_ID,
} from '@/modules/core/hooks/useDetectActiveTOCModule';

import { useHealthPlanModules, useProgressScroll } from './Sidebar/hooks';
import Sidebar from './Sidebar';

interface Props {
  children: React.ReactNode;
  isTemplateModeApplied?: boolean;
  isHealthPlanActive?: boolean
}
const PlanSetupWrapper: React.FC<Props> = ({ children, isHealthPlanActive, isTemplateModeApplied }) => {
  const config = useHealthPlanModules();

  const { onScrollHandler, scrollToSection } = useProgressScroll(config);

  return (
    <Box
      direction="row"
      overflow="hidden"
      flex={{ grow: 1 }}
    >
      <Sidebar
        scrollToSection={scrollToSection}
        isTemplateModeApplied={isTemplateModeApplied}
        isHealthPlanActive={isHealthPlanActive}
      />
      <Box
        fill
        overflow="auto"
        onScroll={onScrollHandler}
        id={SETUP_CONTAINER_UI_ID}
        align="center"
      >
        {children}
      </Box>
    </Box>
  );
};

export default PlanSetupWrapper;
